// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"58bb8dd7","333":"00a4e72a","483":"80826947","493":"0b07725d","613":"47a2f2c7","617":"f8448c78","645":"2be4e9e4","739":"05424aae","813":"e080c246","849":"87b042a1","881":"5e9d1444","971":"9b780b61"}[chunkId] + ".chunk.js";
};